export default __webpack_public_path__ + "static/media/MaticX.939d9ab7.svg";